import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { processConfirmation, verifyUser } from '../../actions/UserActions';

export default function useEmailVerification() {
    const [ verificationCode, setVerificationCode ] = useState({
        sentEmail: false,
        codeVerified: false
    });
    const [ status, setStatus ] = useState({
        hasError: false,
        errorMessage: ''
    });
    const { confirmationEmailSent, emailSentResponse, userVerified,
        verificationResponse } = useSelector(state => ({
        confirmationEmailSent: state.user.confirmationEmailSent,
        emailSentResponse: state.user.emailSentResponse,
        userVerified: state.user.userVerified,
        verificationResponse: state.user.verificationResponse
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        if (confirmationEmailSent) {
            setVerificationCode((prevState) => ({
                ...prevState,
                sentEmail: true
            }));
        } else if (emailSentResponse) {
            setStatus({
                hasError: true,
                errorMessage: 'Error sending verification email'
            });
        }
    }, [confirmationEmailSent, emailSentResponse]);

    useEffect(() => {
        if (userVerified) {
            setVerificationCode((prevState) => ({
                ...prevState,
                codeVerified: true
            }));
        } else if (verificationResponse) {
            setStatus({
                hasError: true,
                errorMessage: 'Error verifying confirmation code'
            });
        }
    }, [userVerified, verificationResponse]);

    function requestVerification(individualEmailId) {
        dispatch(verifyUser({ individualEmailId: individualEmailId }));
    }

    function verifyConfirmationCode(confirmationRequest) {
        dispatch(processConfirmation(confirmationRequest));
    }

    return { verificationCode, setVerificationCode, status, setStatus,
        confirmationEmailSent, emailSentResponse, userVerified,
        verificationResponse, requestVerification, verifyConfirmationCode };
}
